import React, { useMemo } from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import { useItems } from '../../hooks'

import ListHeader from '../../components/ListHeader'
import ListTable from '../../components/ListTable'

const columns = [
  { header: 'Id', value: (item) => item.id },
  {
    header: 'Name',
    value: (item) => item.name,
    isLink: true,
  },
]

const PermissionsList = () => {
  const [{ response: items, isLoading, error }] = useItems(API_URL)
  const featurePermissions = useMemo(
    () => items && items.filter(({ typeId }) => typeId === 1),
    [items]
  )
  const agencyPermissions = useMemo(
    () => items && items.filter(({ typeId }) => typeId === 2),
    [items]
  )

  if (isLoading) return <div>Loading..</div>
  if (error) return <div>{error}</div>

  return (
    <>
      <ListHeader title="Permissions" routeName={ROUTE_NAME} />
      <ListTable
        title="Feature"
        items={featurePermissions}
        columns={columns}
        routeName={ROUTE_NAME}
      />
      <ListTable
        title="Agency"
        items={agencyPermissions}
        columns={columns}
        routeName={ROUTE_NAME}
      />
    </>
  )
}

export default PermissionsList
